
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"32","viewBox":"0 0 30 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#lost_svg__clip0_2680_179)"}},[_c('path',{attrs:{"d":"M14.956 31.17c8.162 0 14.946-6.77 14.946-14.947 0-8.162-6.8-14.946-14.961-14.946C6.765 1.277.01 8.06.01 16.223.01 24.4 6.779 31.17 14.956 31.17z","fill":"#FCC"}}),_c('path',{attrs:{"d":"M9 10.8l11.7 11.7M20.7 10.8L9 22.5","stroke":"#C91919","stroke-width":"2.925","stroke-linecap":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"lost_svg__clip0_2680_179"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .3)","d":"M0 0h30v31H0z"}})])])])
          )
        }
      }
    